import { useNavigate } from 'react-router-dom'

import { Layout } from '@/modules/shared/layouts/layout'

import { NearbyCustomersInterface } from '../interfaces/nearby-customers.interface'

export function NearbyCustomersContainer() {
  const navigate = useNavigate()
  const handleBackPage = () => {
    navigate('/')
  }
  return (
    <Layout
      pageTitle="Clientes Próximos"
      handleGoBack={handleBackPage}
      className=" md:max-w-full px-0 pt-0"
      hiddenFotters
    >
      <NearbyCustomersInterface />
    </Layout>
  )
}
